import { Button } from '@pwc/pwc-deals-ui';
import classNames from 'classnames';
import styles from './CookiesBanner.module.scss';
import { useCookieBanner } from './CookiesBanner.controller';

const t = {
  title: 'Cookie settings',
  description:
    "In Junction, we use a third-party service to provide our users with in-app help content, including notifications regarding disruptions to service. This service uses cookies to collect data anonymously about how the website is used. The number of visitors, where they came from and the pages viewed are all part of this collected data. By clicking 'Accept', you consent to the usage of these cookies.",
  learnMore: 'Learn more',
  ctaAccept: 'Accept',
  ctaDecline: 'Decline',
};

type Props = {
  setCookies: (isAllowed: boolean) => Promise<void>;
};

const CookiesBannerInner = ({ setCookies }: Props) => {
  return (
    <div className={styles.wrapper}>
      <h3>{t.title}</h3>
      <div className={styles.content}>
        <p>
          {t.description}{' '}
          <a className={styles.link} href="/policies/cookie-statement">
            {t.learnMore}
          </a>
        </p>
        <div className={styles.actions}>
          <Button
            onClick={() => setCookies(true)}
            // eslint-disable-next-line
            className={classNames(styles.actionButton, 'ui-button button-xs')}
            icon=""
            iconClasses=""
          >
            {t.ctaAccept}
          </Button>
          <Button
            onClick={() => setCookies(false)}
            // eslint-disable-next-line
            className={classNames(
              styles.actionButton,
              'ui-button button-xs button-outline'
            )}
            icon=""
            iconClasses=""
          >
            {t.ctaDecline}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const CookiesBanner = () => {
  const { setCookies, showCookieBanner } = useCookieBanner();

  if (!showCookieBanner) {
    return null;
  }

  return <CookiesBannerInner setCookies={setCookies} />;
};
